import React from "react";
import RecordContainer from "../../components/Record/RecordContainer";

const BackgroundCheckReportPage = () => {
    document.title = window.location.href.includes("backgroundcheck")
        ? "Background Check"
        : "Data Worker"
    return <RecordContainer backgroundCheck={true} />
}

export default BackgroundCheckReportPage;
